import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var WhyOrderCancelledIA = function WhyOrderCancelledIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize), IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "JDvEit",
    defaultMessage: [{
      "type": 0,
      "value": "As contas têm de ser verificadas para poderem receber encomendas de marcas na Faire"
    }]
  });
};
var WE_VERIFY_ALL_NEW_ACCOUNTS = function WE_VERIFY_ALL_NEW_ACCOUNTS(strictLocalize) {
  return strictLocalize({
    id: "3HQ2jm",
    defaultMessage: [{
      "type": 0,
      "value": "Verificamos todas as novas contas para manter um marketplace seguro. Se não for possível verificar a sua conta, todas as encomendas existentes serão canceladas. Não lhe será debitado qualquer valor."
    }]
  });
};
var IF_YOU_HAVE_ANY_QUESTIONS = function IF_YOU_HAVE_ANY_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "WVf5FE",
    defaultMessage: [{
      "type": 0,
      "value": "Se tiver alguma dúvida, prossiga para contactar-nos e entraremos em contacto consigo assim que possível."
    }]
  });
};